module.exports = __webpack_public_path__ + "src/assets/img/icon_3.42191762.svg";